<script>
  import { createEventDispatcher, getContext } from 'svelte'
  import Scroller from '@sveltejs/svelte-scroller'
  import ModalBackLink from '../../components/ModalBackLink'
  import { EntryDetailCard } from '../entries'
  import WaypointScrollerSection from './WaypointScrollerSection.svelte'

  export let waypoints = []
  export let activeWaypoint
  export let threshold = 0.3

  $: visibleWaypoints = waypoints.filter(wp => wp.isStop() || wp.hasContent())

  export const scrollToWaypoint = (waypoint) => {
    if (waypoint) {
      const waypointPositionY = document.querySelector(`#${waypoint.id}`).offsetTop
      const targetScrollY = waypointPositionY + (window.innerHeight * threshold)
      autoScrollingTarget = targetScrollY
      window.scrollTo({ left: window.scrollX, top: targetScrollY, behavior: 'smooth' })
    }
  }

  const { open: openModal } = getContext('simple-modal')
  const dispatch = createEventDispatcher()
  const DISPATCH_SOURCE = 'timeline'

  let scrollY, index
  let autoScrollingTarget = 0

  $: if (Math.abs(autoScrollingTarget - scrollY) < 2) autoScrollingTarget = 0
  $: if (!autoScrollingTarget) dispatch('waypoint-activated', { waypoint: visibleWaypoints[index], source: DISPATCH_SOURCE })

  const openEntryModal = (entry) => {
    openModal(
      EntryDetailCard,
      { entry, modal: true },
      {
        styleWindowWrap: { maxHeight: 'none' },
        styleWindow: {},
        styleContent: { paddingTop: 0 },
        closeButton: ModalBackLink
      }
    )
  }
</script>

<svelte:window bind:scrollY />
<div class='timeline-scroller'>
  <Scroller query='li.waypoint' {threshold} bind:index>
    <div slot='foreground'>
      <div class='timeline-scroller-content'>
        <h2 class='sr-only'>Timeline</h2>
        <ol class='list-waypoints'>
          {#each visibleWaypoints as wp (wp.id)}
            <li class='waypoint' id={wp.id}>
              <WaypointScrollerSection
                waypoint={wp}
                active={wp === activeWaypoint}
                on:entry-click={({detail: entry}) => openEntryModal(entry)}
              />
            </li>
          {/each}
        </ol>
      </div>
    </div>
  </Scroller>
</div>

<style>
  .timeline-scroller {
    --timeline-line-width: var(--border-width-xthick);
    --timeline-line-color: var(--color-grey-xdark);
    --timeline-container-padding: max(var(--timeline-inline-spacer), var(--spacer-lg));

    background: var(--bg-color-accent);
    padding-inline: var(--timeline-container-padding);
    overflow-y: auto;
    overflow-x: hidden;
  }

  ol {
    margin: 0;
    padding: 0;
  }

  li {
    list-style-type: none;
    margin-bottom: var(--spacer-xs);
    padding: var(--spacer-sm);
  }

  .list-waypoints {
    --waypoint-padding-left: var(--spacer-xl);
    padding-left: var(--waypoint-padding-left);
  }

  .list-waypoints::before {
    border-top: var(--timeline-line-width) solid var(--timeline-line-color);
    content: '';
    position: absolute;
    left: calc(var(--timeline-container-padding) * -0.5 + var(--timeline-line-width) * 0.5);
    top: 0;
    bottom: 0;
    width: var(--spacer-lg);
    border-top: var(--timeline-line-width) solid var(--timeline-line-color);
    border-bottom: var(--timeline-line-width) solid var(--timeline-line-color);
    display: inline-block;
  }

  .list-waypoints::after {
    position: absolute;
    content: '';
    top: 0;
    bottom: 0;
    left: 0;
    border-left: var(--timeline-line-width) solid var(--timeline-line-color);
  }

  .list-waypoints li.waypoint {
    position: relative;
    padding: var(--spacer-lg) 0;

    /* Spacing to allow background bleed when active */
    margin-left: calc(var(--waypoint-padding-left) * -1);
    padding-left: calc(var(--waypoint-padding-left));
    margin-right: -100vh;
    padding-right: 100vh;
  }

</style>
